import { css, CSSResult } from 'lit'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorAction, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const cseLink = {
  gap: css`var(--cse-link-gap, ${csSpacing.spacing03})`,
  primaryColor: css`var(--cse-link-primary-color, ${csColorAction.linkPrimary})`,
  primaryColorHover: css`var(--cse-link-primary-color-hover, ${csColorAction.linkPrimaryHover})`,
  secondaryColor: css`var(--cse-link-secondary-color, ${csColorAction.linkSecondary})`,
  secondaryColorHover: css`var(--cse-link-secondary-color-hover, ${csColorAction.linkSecondaryHover})`,
  whiteColor: css`var(--cse-link-white-color, ${csColorAction.linkWhite})`,
  whiteColorHover: css`var(--cse-link-white-color-hover, ${csColorAction.linkWhiteHover})`,
  textDecorationLine: css`var(--cse-link-text-decoration-line, underline)`,
  disabledColor: css`var(--cse-link-disabled-color, ${csColorText.muted})`,
  textAlign: css`var(--cse-link-text-align, inherit)`,
}

export const style: CSSResult = css`
  .cse-link {
    background: none;
    border: none;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: ${cseLink.gap};
    padding: 0;
    text-align: ${cseLink.textAlign};
    transition-duration: ${csTransition.duration};
    transition-property: color, text-decoration;
    transition-timing-function: ${csTransition.timingFunction};
    cursor: pointer;
  }

  .link-text {
    display: inline;
  }

  .font-body .link-text,
  .font-body-s .link-text {
    text-decoration-line: ${cseLink.textDecorationLine};
    text-decoration-style: solid;
  }

  .variant-primary {
    color: ${cseLink.primaryColor};
    text-decoration-color: ${cseLink.primaryColor};
  }

  .variant-secondary {
    color: ${cseLink.secondaryColor};
    text-decoration-color: ${cseLink.secondaryColor};
  }

  .variant-white {
    color: ${cseLink.whiteColor};
    text-decoration-color: ${cseLink.whiteColor};
  }

  .variant-primary:hover {
    color: ${cseLink.primaryColorHover};
    text-decoration-color: ${cseLink.primaryColorHover};
  }

  .variant-secondary:hover {
    color: ${cseLink.secondaryColorHover};
    text-decoration-color: ${cseLink.secondaryColorHover};
  }

  .variant-white:hover {
    color: ${cseLink.whiteColorHover};
    text-decoration-color: ${cseLink.whiteColorHover};
  }

  .disabled,
  .disabled:hover {
    color: ${cseLink.disabledColor};
    text-decoration-color: ${cseLink.disabledColor};
    cursor: not-allowed;
  }
`
